<script setup lang="ts">
import type { ComputedRef } from "vue";
import { SelectItemText, type SelectItemTextProps, useForwardProps } from "reka-ui";

const props = withDefaults(defineProps<SelectItemTextProps>(), {});
// Only the set props; typed as such (see HPixSelectArrow).
const forwarded = useForwardProps(props) as ComputedRef<SelectItemTextProps>;
</script>

<template>
  <SelectItemText v-bind="forwarded">
    <slot />
  </SelectItemText>
</template>
